import React, { useState, useEffect } from "react";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useUser } from "@/redux/user";
import { useRegister, setRecoveryCode } from "@/redux/register";
import Popup from "@/components/ui/popup";
import { Button } from "@/components/ui/button";
import RecoveryCodePanel from "./RecoveryCodePanel";

/** Lives above signup entry points, which may unmount as soon as a guest becomes a member. */
export default function AccountRecoveryNotice() {
  const { recoveryCode, username } = useRegister();
  const { memberLoggedIn } = useUser();
  const { t } = useTranslation("auth");
  const { t: commonT } = useTranslation("common");
  const router = useRouter();
  const [saved, setSaved] = useState(false);
  useEffect(() => setSaved(false), [recoveryCode]);
  if (!recoveryCode || !memberLoggedIn) return null;
  return (
    <Popup title={t("Welcome to ChessHotel")} maxWidth="464px" scrollable>
      <RecoveryCodePanel
        key={recoveryCode}
        code={recoveryCode}
        username={username}
        onSaved={setSaved}
      />
      <Button
        className="mt-4 w-full"
        disabled={!saved}
        onClick={() => {
          setRecoveryCode(null);
          setSaved(false);
          window.dispatchEvent(new Event("chesshotel:recovery-saved"));
          if (router.pathname === "/register") {
            const returnTo = router.query.returnTo;
            router.push(
              typeof returnTo === "string" &&
                returnTo.startsWith("/") &&
                !returnTo.startsWith("//")
                ? returnTo
                : "/learn"
            );
          }
        }}
      >
        {commonT("Continue")}
      </Button>
    </Popup>
  );
}
